/**
 * The setup prompt a user pastes into their Hermes chat. The agent runs one fixed command that
 * downloads the MCP server, verifies its checksum and redeems the single-use setup code; all logic
 * lives in the verified program (tools/dashboard-mcp/src/setup.ts), none is left to the model.
 * Paths match the devbox Hermes layout (data folder mounted at /opt/data).
 */

export interface SetupPromptInput {
  setupCode: string;
  origin: string;
  file: string;
  sha256: string;
}

export function buildSetupPrompt({ setupCode, origin, file, sha256 }: SetupPromptInput): string {
  const command = [
    'mkdir -p /opt/data/dashboard-mcp && cd /opt/data/dashboard-mcp &&',
    `curl -fsSL -o ${file} ${origin}/agent/${file} &&`,
    `echo "${sha256}  ${file}" | sha256sum -c - &&`,
    `node ${file} setup --code ${setupCode} --config /opt/data/config.yaml --data-dir /opt/data`,
  ].join(' ');
  return [
    "Set up my Darling's Dashboard connection. Run exactly this one command in your terminal and show me its full output:",
    '',
    command,
    '',
    'Do not change, split or retry the command. If it prints "SETUP COMPLETE", tell me to send /reload-mcp. If it prints an error, show me the error.',
  ].join('\n');
}
